<template>
	<div class="logistics-detail-drawer">
		<el-drawer :visible.sync="drawer" title="样品订单详情" size="725px" :before-close="handleClose">
			<div class="drawer-wrap">
				<div class="content">
					<div class="yx-color-text-primary font-h3-medium mb-12">
						{{ currentItem.is_refuse_delivery == 1 ? currentItem.is_refuse_delivery_desc : currentItem.delivery_status_desc }}
					</div>
					<div>
						<el-button type="primary" v-if="showTakeBtn" plain class="notarize" @click="confirmation">确认收货</el-button>
						<el-button v-if="hasNotDeliver && $auth.hasPermi('system:sampleOrder:deliver') && currentItem.is_refuse_delivery != 1" @click="sendGoodsFun" type="primary" plain>
							发货
						</el-button>
					</div>
					<el-tabs v-model="activeName" @tab-click="handleClick" class="mt-6">
						<el-tab-pane label="申样信息" name="0"></el-tab-pane>
						<el-tab-pane label="物流信息" name="1"></el-tab-pane>
					</el-tabs>
					<template v-if="activeName === '0'">
						<div class="card-box1 radius-4">
							<user-info-box :row="row"></user-info-box>
						</div>
						<div class="card-box2 mt-8 radius-4">
							<div class="label mb-20">商品信息及申样规格</div>
							<div class="product">
								<product-box :row="row" :tabName="tabName"></product-box>
							</div>
							<div class="mt-20" v-if="sku_list.length">
								<sample-specs-view ref="sampleSpecsView" class="flex-1" :sku_list="sku_list"></sample-specs-view>
							</div>
						</div>
						<div class="card-info">
							<div class="label">申样信息</div>
							<div class="mt-20 fz-14">
								<div class="yx-color-info">
									申样时间：
									<span class="yx-color-text-primary">{{ currentItem.add_time }}</span>
								</div>
								<div class="flex mt-4 flex-align-center" v-if="hasNotDeliver">
									<p class="yx-color-info">商家跟进</p>
									<p class="yx-color-text-primary ml-4" v-if="showContact">已联系商家</p>
									<p class="yx-color-warning ml-4" v-if="showNotContact">未联系商家</p>
									<div class="flex flex-align-center contact-tag ml-4" v-auth="['system:sampleOrder:remark']">
										<div class="track-record"></div>
										<p class="fz-12 ml-4 pointer" @click="settingRemarks()">跟进备注</p>
									</div>
								</div>
								<div class="mt-12 yx-color-info">
									申样备注：
									<span class="yx-color-text-primary">{{ currentItem.buyer_remark }}</span>
								</div>
								<div class="yx-color-info mt-12 flex">
									<div>收货信息：</div>
									<div class="yx-color-text-primary">
										<div>{{ delivery_address.delivery_name }} {{ delivery_address.delivery_mobile }}</div>
										<div>{{ delivery_addr }}</div>
									</div>
								</div>
							</div>
							<div class="mt-20">
								<el-button v-auth="['system:Modified-sample-information']" @click="showUpdateSampleDialog">修改申样信息</el-button>
								<el-button @click="copyDetails">复制申样信息</el-button>
							</div>
						</div>
					</template>
					<template v-else>
						<el-button-group class="mt-12 btn-group" v-if="packageList.length > 1">
							<el-button :class="{ active: index === currentIndex }" @click="currentIndex = index" v-for="(item, index) in packageList" :key="index">
								包裹{{ index + 1 }}
							</el-button>
						</el-button-group>
						<div class="card-info mt-10">
							<div class="label">物流信息</div>
							<div class="mt-20 fz-14">
								<div class="yx-color-info">
									物流状态：
									<span class="yx-color-text-primary">{{ currentItem.delivery_status_desc }}</span>
								</div>
								<div class="yx-color-info mt-12">
									发货时间：
									<span class="yx-color-text-primary">{{ currentItem.delivery_time }}</span>
								</div>
								<div class="yx-color-info mt-12">
									物流公司：
									<span class="yx-color-text-primary">{{ packageItem.shipping_company }}</span>
								</div>
								<div class="yx-color-info mt-12">
									物流单号：
									<span class="yx-color-text-primary">{{ packageItem.shipping_sn }}</span>
								</div>
							</div>
							<div class="mt-20" v-if="$auth.hasPermi('system:edit-logistics') && !hasNotDeliver">
								<el-button @click="showUpdateLogisticsDialog">修改物流信息</el-button>
							</div>
						</div>
						<div class="card-info">
							<div class="label">物流动态</div>
							<div class="timeline-box">
								<el-timeline>
									<el-timeline-item color="#BDD5FF" :timestamp="item.status" placement="top" v-for="(item, index) in delivery_data" :key="index">
										<div class="row">
											<div class="text">{{ item.context }}</div>
											<div class="time">{{ item.ftime }}</div>
										</div>
									</el-timeline-item>
								</el-timeline>
							</div>
						</div>
					</template>
				</div>
				<div class="bottom-btn">
					<el-button type="primary" @click="handleClose">我知道了</el-button>
				</div>
			</div>
		</el-drawer>
		<update-sample-dialog
			ref="updateSampleDialog"
			:platformId="row.platform_id"
			@getList="refreshList"
			:thirdProductId="third_product_id"
			:productId="product_id"
		/>
		<update-logistics-dialog ref="updateLogisticsDialog" @getList="refreshList" />
		<remarks ref="remarks" @refreshList="refreshList"></remarks>
		<sampleSendGoods ref="sampleSendGoods" @refresh="refreshList" />
		<take-dialog ref="takeDialog" @getList="refreshList" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import throttle from 'lodash/throttle';
import { deliveryStatus } from '@/utils/dataMap';
import productBox from '@/components/common/productBox';
import userInfoBox from '@/components/common/userInfoBox';
import updateSampleDialog from './components/updateSampleDialog';
import updateLogisticsDialog from './components/updateLogisticsDialog';
import { getDeliverListV2 } from '@/api/cooperationProgress';
import remarks from '@/views/sampleOrder/list/components/remarks';
import sampleSpecsView from '@/components/business/sampleSpecs/view.vue';
import sampleSendGoods from '../sampleSendGoods';
import takeDialog from '../takeDialog.vue';
export default {
	name: 'logisticsDetailDrawer',
	props: {
		tabName: {
			type: String,
			default: '',
		},
	},
	components: {
		productBox,
		userInfoBox,
		updateSampleDialog,
		updateLogisticsDialog,
		remarks,
		sampleSpecsView,
		sampleSendGoods,
		takeDialog,
	},
	data() {
		return {
			drawer: false,
			cooperate_id: '',
			currentIndex: 0,
			row: {},
			currentItem: {},
			type: 0,
			activeName: '0',
			product_id: '',
			third_product_id: '',
		};
	},
	computed: {
		delivery_address() {
			return this.currentItem.delivery_address || {};
		},
		packageList({ currentItem }) {
			return currentItem.delivery_list || [];
		},
		packageItem({ packageList, currentIndex }) {
			return (packageList && packageList[currentIndex]) || {};
		},
		delivery_addr() {
			const { province, city, area, delivery_addr } = this.delivery_address;
			return delivery_addr && delivery_addr.indexOf(`${province}${city}`) !== -1 ? delivery_addr : `${province}${city}${area}${delivery_addr}`;
		},
		delivery_data() {
			return this.packageItem.delivery_info || [];
		},
		showTakeBtn() {
			return (
				this.$auth.hasPermi('system:sampleOrder:confirm') &&
				[deliveryStatus.shipped, deliveryStatus.transit].includes(this.currentItem.delivery_status)
			);
		},
		hasNotDeliver() {
			return this.currentItem.delivery_status === deliveryStatus.notShipped ;
		},
		showContact() {
			const { currentItem } = this;
			return currentItem.contact_status === '1';
		},
		showNotContact() {
			const { currentItem } = this;
			return currentItem.contact_status === '0';
		},
		sku_list({ currentItem }) {
			let list = currentItem.sku_list?.filter(item => Number(item.nums)) || [];
			const { specification_remark } = currentItem;
			if (list.length) {
				list = list.map(item => {
					return {
						...item,
						specification_remark: currentItem.specification_remark,
					};
				});
			} else {
				if (specification_remark) {
					list = [{ specification: '', price: '', nums: '', specification_remark }];
				}
			}
			return list;
		},
		anchorAccount() {
			//获取k抖音号，快手号，视频id
			const temPF = {
				[dataMap.PLATFORM_DY.value]: this.row.anchor_account,
				[dataMap.PLATFORM_KS.value]: this.row.anchor_account,
				[dataMap.PLATFORM_SP.value]: this.row.anchor_uid,
			};
			return temPF[this.row.platform_id];
		},
	},
	methods: {
		show(row, type = 0) {
			this.type = type;
			this.row = row;
			this.cooperate_id = row.cooperate_id;
			this.product_id = row.product_id;
			this.third_product_id = row.third_product_id;
			this.getInfo();
			this.drawer = true;
		},
		handleClose() {
			this.cooperate_id = '';
			this.currentIndex = 0;
			this.activeName = '0';
			this.product_id = '';
			this.row = {};
			this.currentItem = {};
			this.drawer = false;
		},
		async getInfo() {
			const { cooperate_id, type } = this;
			const { sample_sn } = this.row;
			const { code, data } = await getDeliverListV2(type ? { cooperate_id, sample_sn } : { cooperate_id });
			if (code !== 0) return;
			this.currentItem = data;
		},
		async refreshList(showUpdateSampleDialog) {
			await this.getInfo();
			if (showUpdateSampleDialog) {
				await this.showUpdateSampleDialog();
			}
			this.$emit('getList');
		},
		showUpdateSampleDialog() {
			const { cooperate_id, sample_sn, buyer_remark, sku_list, specification_remark } = this.currentItem;
			this.$refs.updateSampleDialog.show({ ...this.delivery_address, cooperate_id, sample_sn, buyer_remark, skus: sku_list, specification_remark });
		},
		showUpdateLogisticsDialog() {
			this.$refs.updateLogisticsDialog.show({ ...this.packageItem, sample_sn: this.currentItem.sample_sn });
		},
		confirmation: throttle(async function () {
			const { cooperate_id, sample_sn } = this.currentItem;
			this.$refs.takeDialog.show(cooperate_id, sample_sn);
		}, 1000),
		sendGoodsFun() {
			this.$refs.sampleSendGoods.show(this.row);
		},
		copyDetails() {
			const { delivery_address, row } = this;
			const { province, city, area, delivery_addr } = delivery_address;
			const { sku_list, specification_remark } = this.currentItem;
			let sku = '';
			let filterSku = sku_list.filter(item => Number(item.nums));
			filterSku.forEach(item => {
				sku += `${item.specification} * ${item.nums}`;
			});
			let adress = delivery_addr && delivery_addr.indexOf(`${province}${city}`) !== -1 ? delivery_addr : province + city + area + delivery_addr;
			let copy_value = `商品名：${row.product_name}\r\n商品id：${row.third_product_id}\r\n店铺：${
				row.shop_name
			}\r\n申样和数量：${sku}\r\n申样规格备注：${specification_remark}\r\n达人昵称：${row.anchor_name}\r\n${row.platform_desc.replace('号', '')}号：${
				this.anchorAccount
			}\r\n粉丝量：${row.fans_num}\r\n场均销售额：${row.live_sale}\r\n带货类型：${row.sell_goods_desc}\r\n申样备注：${
				row.buyer_remark || '无'
			}\r\n收件人：${delivery_address.delivery_name}\r\n收件电话：${delivery_address.delivery_mobile}\r\n收件地址：${adress}`;
			var inputTest = document.createElement('textarea');
			inputTest.value = copy_value;
			document.body.appendChild(inputTest);
			inputTest.select();
			document.execCommand('Copy');
			inputTest.className = 'oInput';
			inputTest.style.display = 'none';
			this.$message.success('复制成功');
			document.body.removeChild(inputTest);
		},
		settingRemarks() {
			this.$refs.remarks.show(this.currentItem);
		},
		handleClick(tab, event) {},
	},
};
</script>

<style lang="less" scoped>
.logistics-detail-drawer {
	.drawer-wrap {
		background: #fff;
		height: 100%;
		overflow: hidden;
		padding-bottom: 61px;

		.content {
			height: 100%;
			position: relative;
			overflow-y: auto;
			padding: 24px;
			padding-top: 8px;
			box-sizing: border-box;

			.card-box1 {
				background-color: #f8fbff;
				padding: 12px;
			}

			.card-box2 {
				background-color: #f8fbff;
				padding: 24px;

				.product {
					background-color: #fff;
					padding: 12px;
				}
			}

			.btn-group {
				.el-button {
					z-index: 0;
					color: #333333;
					border-color: #e3e3e3;
					background-color: #fff;

					&.active {
						color: #2069e6;
						border-color: #2069e6;
						outline: none;
						background-color: #e9f1ff;
						z-index: 1;
					}
				}
			}

			.card-info {
				margin-top: 16px;
				padding: 24px;
				background-color: #fafafd;

				.notarize {
					background-color: #e9f1ff !important;
				}

				.timeline-box {
					margin-top: 20px;
					padding-left: 130px;

					::v-deep .el-timeline-item {
						&:nth-child(1) {
							.el-timeline-item__node {
								background-color: @color-primary !important;
							}

							.el-timeline-item__timestamp {
								font-size: 14px;
								color: #323233;
								font-weight: 700;
							}
						}

						.el-timeline-item__timestamp {
							color: #666;
						}
					}

					.row {
						position: relative;

						.text {
							font-size: 12px;
							color: #999;
						}

						.time {
							position: absolute;
							top: -22px;
							left: -156px;
							font-size: 12px;
							color: #666;
						}
					}
				}
			}
		}
	}

	.contact-tag {
		height: 18px;
		line-height: 18px;
		border-radius: 2px;
		text-align: center;
		padding: 0px 3px;
		font-weight: 400;
		background-color: #ebf2fd;
		color: @color-primary;
	}

	.bottom-btn {
		border-top: 1px solid #eee;
		text-align: right;
		padding: 14px 24px;
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
	}

	.label {
		font-size: 14px;
		font-weight: 700;
		position: relative;

		&::before {
			content: '';
			position: absolute;
			left: -8px;
			top: 3px;
			width: 2px;
			height: 14px;
			border-radius: 1px;
			background-color: @color-primary;
		}
	}

	::v-deep .el-tabs__nav-wrap::after {
		background-color: transparent;
	}
}
</style>
